import React from 'react';
import PropTypes from 'prop-types';
import {
  Label,
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';

const LimitCounter = ({ style, current, limit, primaryText, customText, t }) => (
  <Label className="limit-counter" style={style}>
    {
      customText ?
      customText({ current, limit }) :
      `${current} ${t('of', { ns: 'translation' })} ${limit} ${primaryText || t('items', { ns: 'translation' })} ${t('selected', { ns: 'translation' })}`
    }
  </Label>
);

LimitCounter.propTypes = {
  style: PropTypes.shape({
    float: PropTypes.string,
  }),
  current: PropTypes.number,
  limit: PropTypes.number,
  primaryText: PropTypes.string,
  customText: PropTypes.func,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(LimitCounter);



// WEBPACK FOOTER //
// ./src/components/LimitCounter.jsx